import React, { SVGAttributes, Ref, forwardRef } from "react"
import { IShape } from "../entites"
import { buildPath } from "./utils"

interface IProps extends SVGAttributes<SVGPathElement> {
  shape: IShape
  fill?: string
  onSelected?: (shape: IShape) => void
}

export const Path = forwardRef<SVGPathElement, IProps>((props: IProps, ref: Ref<SVGPathElement>) => {
  const { shape, fill, onSelected, onClick, ...rest } = props

  return (
    <path
      ref={ref}
      d={buildPath(shape)}
      fill={fill}
      stroke="gray"
      strokeWidth={1}
      onClick={(e: React.MouseEvent<SVGPathElement, MouseEvent>): void => {
        if (onSelected) {
          onSelected(shape)
        } else {
          onClick && onClick(e)
        }
      }}
      style={{
        position: "relative",
      }}
      {...rest}
    ></path>
  )
})

Path.displayName = "Path" 
